import { oz } from '@weft/utils';
import { CommercialTermsPricingSchema } from '../product-variant/fixed-product-variants/commercial-terms/commercial-terms-pricing-schema';
import { CommissionPricingSchema } from '../product-variant/fixed-product-variants/fixed-commission/commission-pricing-schema';
import { OneTimePricingSchema } from '../product-variant/fixed-product-variants/fixed-one-time/one-time-pricing-schema';
import { FixedPerUnitPricingSchema } from '../product-variant/fixed-product-variants/fixed-per-unit/fixed-per-unit-pricing-schema';
import { InstallmentsPricingSchema } from '../product-variant/fixed-product-variants/installments/installments-pricing-schema';
import { RefundPricingSchema } from '../product-variant/fixed-product-variants/refund/refund-pricing-schema';
import { SubscriptionPricingSchema } from '../product-variant/fixed-product-variants/subscription/subscription-pricing-schema';
import { PerUnitPricingSchema } from '../product-variant/usage-product-variants/per-unit/per-unit-pricing-schema';
import { TieredSubscriptionPricingSchema } from '../product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-schema';
import { TiersPricingSchema } from '../product-variant/usage-product-variants/tiers/tiers-pricing-schema';

export const PricingSchema = oz.discriminatedUnion('pricingModel', [
  PerUnitPricingSchema,
  TiersPricingSchema,
  TieredSubscriptionPricingSchema,
  OneTimePricingSchema,
  FixedPerUnitPricingSchema,
  SubscriptionPricingSchema,
  InstallmentsPricingSchema,
  CommercialTermsPricingSchema,
  CommissionPricingSchema,
  RefundPricingSchema,
]).openapi('Pricing');

export type Pricing = oz.infer<typeof PricingSchema>;